<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="4" md="3" lg="2">
      <FilterSelect
        :items="filterChargeStatus"
        :fetchData="fetchCharges"
        item-value="value"
        item-text="label"
        label="Status"
        type="status"
      />
    </v-col>
    <v-col cols="12" sm="4" md="3" lg="3">
      <FilterDates :fetchData="fetchCharges" :dateRange="true" />
    </v-col>
  </v-row>
</template>

<script>
import FilterDates from '@/components/filters/FilterDates'
import FilterSelect from '@/components/filters/FilterSelect'

import { mapActions } from 'vuex'

export default {
  name: 'ChargeListFilters',

  components: {
    FilterDates,
    FilterSelect,
  },

  methods: {
    ...mapActions(['fetchCharges']),
  },

  data() {
    return {
      filterChargeStatus: [
        { label: this.$t('charge.status.PENDING'), value: 'PENDING' },
        { label: this.$t('charge.status.RECEIVED'), value: 'RECEIVED' },
        { label: this.$t('charge.status.CONFIRMED'), value: 'CONFIRMED' },
        { label: this.$t('charge.status.OVERDUE'), value: 'OVERDUE' },
        { label: this.$t('charge.status.OTHER'), value: 'OTHER' },
      ],
    }
  },
}
</script>
